export default __webpack_public_path__ + "static/bottomEnrolment-d94cb7ef0db25e8d59c20714bbdea0cc.jpg";